import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const NavigationButton = ({ 
  text = "View Full List", 
  to = "/", 
  color = "#044A8C", 
  variant = "outline", 
  className = "" 
}) => {
  const navigate = useNavigate();

  const getStyles = () => {
    if (variant === "solid") {
      return {
        backgroundColor: color,
        color: "#ffffff",
        border: "1px solid rgba(255,255,255,0.1)",
      };
    }
    return {
      borderColor: `${color}44`, // Border transparan 
      color: color,
      backgroundColor: "transparent",
    };
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className={`mt-10 text-center relative group ${className}`}
    >
      <button 
        onClick={() => navigate(to)}
        style={getStyles()}
        className={`
          relative overflow-hidden w-full py-5 rounded-2xl font-black text-[11px] 
          uppercase tracking-[0.3em] transition-all duration-500 border
          active:scale-[0.97] shadow-sm hover:shadow-2xl hover:shadow-${color}/20
          flex items-center justify-center gap-3
        `}
      >
        {/* Efek Shimmer (Kilatan Cahaya Bergerak) */}
        <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] transition-transform" />

        {/* Glossy Overlay untuk efek 3D halus */}
        <span className="absolute inset-0 w-full h-full bg-gradient-to-b from-white/10 to-transparent opacity-50" />

        <span className="relative z-10">{text}</span>

        {/* Icon Arrow Dinamis */}
        <motion.span 
          className="relative z-10"
          animate={{ x: [0, 5, 0] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
        >
          →
        </motion.span>

        {/* Hover Background Logic */}
        <style dangerouslySetInnerHTML={{ __html: `
          @keyframes shimmer {
            100% { transform: translateX(100%); }
          }
          .group:hover button {
            background-color: ${color} !important;
            color: white !important;
            border-color: ${color} !important;
          }
        `}} />
      </button>
    </motion.div>
  );
};

export default NavigationButton;